import {Platform, StyleSheet, TextStyle, ViewStyle} from "react-native";
import {WEB_MAXWIDTH} from "../../constants";
import {IsMobile} from "./index";
// import { UIColor } from "./colors";

export type Style = ViewStyle | TextStyle;

export type StyleArray = Array<Style>;

export const styles = StyleSheet.create({
  center: {
    justifyContent: "center",
    alignItems: "center",
  },
  flex1: {
    flex: 1,
  },
  heading: {
    fontSize: 24,
    fontWeight: "600",
    // color: UIColor.TEXT,
  },
  textCenter: {
    textAlign: "center",
  },
  mobileinputs: {
    //  backgroundColor:UIColor.BACKGROUND,
    paddingRight:15
  },
  desktopinput: {
    width: 380,
    height: 50,
    justifyContent: "center",
    // backgroundColor:UIColor.BACKGROUND
    paddingRight:15
  },
  desktopContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  moileContainer: {
    flex: 1,
    justifyContent: "center",
  },

  text: {
    // color: UIColor.TEXT,
    fontWeight: "500",
  },
  title: {
    fontSize: 22,
    fontWeight: "600",
    width: "65%",
    paddingBottom: 50
  },
  errorText: {
    color: "red",
    marginTop: 5,
  },
  webContainer: {
    width: !IsMobile ? WEB_MAXWIDTH : "100%",
    padding: !IsMobile ? 20: 0,
    maxWidth: !IsMobile ? WEB_MAXWIDTH : "100%",
    alignSelf: "center",
    paddingHorizontal: 20,
  }
});
